import { auth } from "./auth"
import { courses } from "./courses"
import { activities } from "./activities"
import { weeklyObjectives } from "./weekly-objectives"
import { user } from "./user"
import { onboarding } from "./onboarding"
import { cosmos } from "./cosmos"
import { productTour } from "./user/product-tour"
import { tracking } from "./tracking"

export const cronos = {
  auth,
  courses,
  activities,
  weeklyObjectives,
  user,
  onboarding,
  cosmos,
  productTour,
  tracking,
}
